import React from 'react'
import { useNavigate } from 'react-router-dom'

export default function Terms() {
  const navigate = useNavigate()
  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#f8f9fa', fontFamily: "'Inter', -apple-system, sans-serif" }}>
      <div style={{ backgroundColor: '#fff', borderBottom: '1px solid #f0f0f0' }}>
        <div style={{ maxWidth: 720, margin: '0 auto', padding: '16px 20px', display: 'flex', alignItems: 'center', gap: 16 }}>
          <button onClick={() => navigate('/')} style={{ background: 'none', border: 'none', color: '#2D7A3A', fontSize: 15, cursor: 'pointer', padding: 0 }}>‹ Späť</button>
          <span style={{ fontWeight: 700, color: '#1a1a1a' }}>Podmienky použitia</span>
        </div>
      </div>
      <div style={{ maxWidth: 720, margin: '0 auto', padding: '40px 20px', lineHeight: 1.8, color: '#444', fontSize: 15 }}>
        <p style={{ color: '#888', fontSize: 13, marginBottom: 32 }}>Posledná aktualizácia: 23. marca 2026</p>

        <h2 style={{ fontSize: 18, fontWeight: 700, color: '#1a1a1a', marginBottom: 12 }}>1. Popis služby</h2>
        <p>Vigilant je systém na monitorovanie pohybu pozostávajúci z fyzického zariadenia (senzora) a mobilnej/webovej aplikácie. Služba slúži na informačné účely — upozorňuje na pohybové udalosti, nie je certifikovaným zdravotníckym ani bezpečnostným systémom.</p>

        <h2 style={{ fontSize: 18, fontWeight: 700, color: '#1a1a1a', margin: '28px 0 12px' }}>2. Obmedzenie zodpovednosti</h2>
        <p>Vigilant nie je náhradou za núdzové záchranné služby (112). Prevádzkovateľ nenesie zodpovednosť za škody vzniknuté výpadkom internetu, elektrickej energie, alebo oneskorením doručenia upozornení mimo nášho vplyvu. Odporúčame Vigilant používať ako doplnkový nástroj.</p>

        <h2 style={{ fontSize: 18, fontWeight: 700, color: '#1a1a1a', margin: '28px 0 12px' }}>3. Používateľský účet</h2>
        <ul style={{ paddingLeft: 20 }}>
          <li>Registrácia vyžaduje platnú e-mailovú adresu</li>
          <li>Za bezpečnosť hesla zodpovedá používateľ</li>
          <li>Jeden účet môže spravovať viacero zariadení</li>
          <li>Účet je možné kedykoľvek zmazať v nastaveniach</li>
        </ul>

        <h2 style={{ fontSize: 18, fontWeight: 700, color: '#1a1a1a', margin: '28px 0 12px' }}>4. Platba a vrátenie</h2>
        <p>Fyzické zariadenie sa platí jednorazovo pri objednávke. Aplikácia je zadarmo bez skrytých poplatkov. Na zariadenie poskytujeme 14-dňovú záruku vrátenia bez udania dôvodu. V prípade vady zariadenia riešime reklamáciu do 30 dní.</p>

        <h2 style={{ fontSize: 18, fontWeight: 700, color: '#1a1a1a', margin: '28px 0 12px' }}>5. Zakázané použitie</h2>
        <ul style={{ paddingLeft: 20 }}>
          <li>Sledovanie osôb bez ich vedomia a súhlasu</li>
          <li>Komerčné ďalšie predávanie zariadenia bez súhlasu</li>
          <li>Zneužitie API alebo automatizované scraping</li>
        </ul>

        <h2 style={{ fontSize: 18, fontWeight: 700, color: '#1a1a1a', margin: '28px 0 12px' }}>6. Kontakt</h2>
        <p>Otázky k podmienkam: podpora@vigilantapp.io</p>
      </div>
    </div>
  )
}
